import React from "react";
import SubscribeButton from "../components/SubscribeButton";

const BillingPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-900 via-gray-900 to-black text-white flex items-center justify-center px-4">
      <div className="w-full max-w-3xl text-center py-10">
        <h1 className="text-4xl md:text-5xl font-extrabold mb-4">Unlock Full Access</h1>
        <p className="text-lg md:text-xl text-gray-300 mb-10">
          Get unlimited storage and full contract management features with the Pro Plan.
        </p>

        <div className="bg-gray-900 rounded-2xl shadow-lg p-8 sm:p-10 mx-auto max-w-md w-full">
          <h2 className="text-xl font-semibold text-blue-400 mb-2">Pro Plan</h2>
          <p className="text-3xl font-bold mb-1">$9.99 <span className="text-base text-gray-400">/ month</span></p>

          <ul className="text-left text-sm sm:text-base text-gray-300 my-6 space-y-3">
            <li>✔ Unlimited contract uploads</li>
            <li>✔ AI-powered contract summaries</li>
            <li>✔ Manage team members and permissions</li>
            <li>✔ Secure cloud-based storage</li>
            <li>✔ Priority support</li>
          </ul>
          
          <SubscribeButton priceId="price_1R6Mc3GKHdCwCPiGSkrilj1g" />

          <p className="text-xs text-gray-500 mt-4">
            Cancel anytime. Secure payments powered by Stripe.
          </p>
        </div>
      </div>
    </div>
  );
};

export default BillingPage;
